export default __webpack_public_path__ + "static/media/SWT0890.34I-21060_-14911_0.9196bac5.jpg";